// extracted by mini-css-extract-plugin
module.exports = {"procedureName":"styles_procedureName__3fGdN","colMin":"styles_colMin__3Fs4a","colCheckbox":"styles_colCheckbox__1Y4j5"};